export default "__VITE_ASSET__3effcfc8__"